// Components/CategoryBanner.jsx
import { Link } from "react-router-dom";
import "../styles/Banner2.css";

const BannerItem = ({ title, subtitle, desc, link, image, isReverse }) => (
  <div className={`category-banner ${isReverse ? "reverse" : ""}`}>
    <div className="banner-left">
      <p className="small-title">{subtitle}</p>
      <h2>{title}</h2>
      <p className="descc">{desc}</p>
      {/* <Link to={link} className="banner-shop-btn">Shop Now</Link> */}
      <Link
        to={link}
        state={{ categoryName: title }}
        className="banner-shop-btn"
      >
        Shop Now
      </Link>
    </div>
    <div className="banner-right">
      <img src={image} alt={title} loading="lazy" />
    </div>
  </div>
);

export default function CategorySection() {
  return (
    <div className="category-wrapper">
      <BannerItem
        subtitle="CELEBRATE WITH LOVE"
        title="Toy Paradise♾️"
        desc="Your one-stop destination for toys, gifts, and collectibles. Discover fun, creativity, and endless smiles with our carefully curated collection for all ages. 🧸"
        link="/category/1781191322715"
        image={require("../assets/xx.png")}
      />


    </div>
  );
}